import * as local from "./systems/local.settings";

const setLanguage = lang => local.setLanguage(lang);

const getLanguage = () => local.getLanguage();

export { getLanguage, setLanguage };
